import * as ng from 'angular';
import * as intlTelInput from 'intl-tel-input/build/js/intlTelInput.min.js';

// global from intl-tel-input
declare var intlTelInputUtils: any;

ng.module('e360')
   .directive('phoneFormat', phoneFormatDirective);

phoneFormatDirective.$inject = ['countries'];
export function phoneFormatDirective(countries) {
   return {
      restrict: 'A',
      require: '^ngModel',
      scope: {
         defaultCountry: '='
      },
      link: phoneFormatLinkFn
   };

   function phoneFormatLinkFn(scope, element, attrs, ctrl:ng.INgModelController) {
      const el = element[0]
      let iti = intlTelInput(el, {
         nationalMode: true,
         onlyCountries: countries
      });

      element.on('$destroy', function() {
         iti.destroy();
         return element.off('change blur');
      });

      scope.$watch('defaultCountry', function(val, old) {
         if (!element.val() && val && val != old) {
            iti.setCountry(val.trim().toLowerCase());
         }
      });

      element.on('countrychange', function(e, countryData) {
         iti.setNumber(iti.getNumber(intlTelInputUtils.numberFormat.NATIONAL));
         ctrl.$validate();
      });

      scope.$watch(() => element.val(), function() {
         if (element.val()) {
            iti.setNumber(iti.getNumber());
            iti.setNumber(iti.getNumber(intlTelInputUtils.numberFormat.NATIONAL));
            ctrl.$setViewValue(element.val());
         }
      });

      scope.$on('phone.save.pre', function() {
         ctrl.$setViewValue(iti.getNumber());
      });

      scope.$on('phone.save.post', function() {
         ctrl.$setViewValue(iti.getNumber(intlTelInputUtils.numberFormat.NATIONAL));
      });

      ctrl.$validators.internationalPhoneNumber = function(value) {
         let selectedCountry = iti.getSelectedCountryData();

         if (!value || (selectedCountry && selectedCountry.dialCode === value)) {
            return true;
         }

         return iti.isValidNumber();
      };

      ctrl.$setPristine();
   }
}
